export const attendanceUrl = process.env.VUE_APP_ATTENDANCE_URL || '';
export const commercialEmail = 'comercial@mobcall.com';
export const supportEmail = 'suporte@mobcall.com';

export const mailtoUrl = (to: string, cc: string, subject: string, body: string) =>
    `mailto:${to}?cc=${encodeURIComponent(cc)}&subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
